<template>
    <div>
        <label v-if="isShowLabel">
            {{ label }}
            <span v-if="required" class="text-danger">*</span>
        </label>
        <input ref="fileupload"
            type="file"
            :name="name"
            class="form-control"
            :value="value"
            @input="change($event.target.value)"
            :class="{
                'is-invalid': error,
            }"
            multiple
        />
        <div
            v-if="error"
            class="invalid-feedback"
        >
            {{ error }}
        </div>
        <slot></slot>
        <div class="mt-2 text-primary" ref="showfilesname"></div>
    </div>    
</template>


<script>
    export default {
        props: {
            label: String,
            name: String,
            value: String,
            error: String,
            required: Boolean,
            isShowLabel: {
                type: Boolean,
                default: true
            },
        },
        methods: {
            change(val) {
                let multiFiles = this.$refs.fileupload.files;
                this.$refs.showfilesname.innerHTML = ''
                for(let i = 0; i < multiFiles.length; i++) {
                    this.$refs.showfilesname.innerHTML += '<i class="mdi mdi-circle-medium"></i> ' + multiFiles[i].name + '<br>'
                }
                this.$emit('input', val)
            },
            fileUpload() {
                return this.$refs.fileupload.files;
            },
            showError(str) {
                this.$refs.showfilesname.innerHTML = str;
            }
        }
    }
</script>

